export default "__VITE_ASSET__KVwQOW9r__"